export const sdgGoalData = {
	peopleServed: 28101,
	ruralCommunitiesReached: 129,
	healthAdvocatesTrained: 20,
	healthHubsEstablished: 2,
};
